/**
 * Default feature flags (all enabled) - Fail open approach
 * This ensures the app doesn't break if feature flags are missing
 */
export const DEFAULT_FEATURE_FLAGS = {
  // Main Navigation Features
  settings: true,
  companies: true,
  contacts: true,
  proposals: true,
  selfServeUsers: true,
  upsellsDownsells: true,
  invoices: true,
  payments: true,
  subscriptions: true,
  plans: true,
  productsAddOns: true,
  markets: true,
  events: true,
  jsonViewer: false,

  // Settings Navigation Features
  yourProfile: true,
  organisationDetails: true,
  integrations: true,
  platformSettings: true,
  billingUnits: true,
  usageSources: true,
  usageCompilation: true,
  usageCollection: true,
  systemFeatures: true,
  billingLogic: true,
  configureSelfCheckout: true,
  userManagement: true,
  roles: true,
  permissions: true,
  imports: true,
  migrations: true,
  exports: true,
  documentManagement: true,
  objectCustomization: true,
  webhooks: true,
  // Default OFF, unlike every other flag here - matches the backend
  // default (middleware/featureFlag.middleware.js) and the "fail open"
  // comment at the top of this file deliberately does not apply to a
  // capability that clones real customer data into a new database. Opt-in
  // per org/environment.
  timeMachine: false,

  // Quick Actions
  companyQuickAction: true,
  proposalQuickAction: true,
  subscriptionQuickAction: true,
  invoiceQuickAction: true,
};
